/** Only public Instagram post/reel permalinks can be embedded. */
export function instagramPostUrl(value: unknown): string | null {
  if (typeof value !== "string") return null;
  try {
    const url = new URL(value);
    if (
      url.protocol !== "https:" ||
      url.username ||
      url.password ||
      url.port ||
      !["instagram.com", "www.instagram.com"].includes(url.hostname)
    )
      return null;
    const match = /^\/(p|reel)\/([A-Za-z0-9_-]{6,64})\/?$/.exec(url.pathname);
    return match ? `https://www.instagram.com/${match[1]}/${match[2]}/` : null;
  } catch {
    return null;
  }
}
